import {
  Component,
  computed,
  inject,
  input,
  output,
  Signal,
} from '@angular/core';
import { NodeIconComponent } from '@shared/ui/node-icon';
import { MaskPipe } from '@shared/ui/pipes';
import { NodesService } from '../../../../nodes';
import { NodeImportRowInterface } from '../import-nodes-modal.interface';

@Component({
  selector: 'shared-store-import-nodes-modal-item',
  templateUrl: './import-nodes-modal-item.component.html',
  styleUrls: ['./import-nodes-modal-item.component.css'],
  imports: [NodeIconComponent, MaskPipe],
})
export class ImportNodesModalItemComponent {
  item = input.required<NodeImportRowInterface>();

  isDisabled = input<boolean>();

  private readonly nodesService = inject(NodesService);

  toggleItem = output();

  itemIconPath: Signal<string> = computed(() =>
    this.nodesService.getNodeModelIcon(this.item()?.entity.hwId),
  );
}
